import c from "lib/style/colorVar.scss";

const dangerColor = c["danger"];
const focusColor = c["brand1"];
const regularColor = c["blackLightDDD"];
const placeholderColor = c["blackDarkAAA"];

export const outlinedInputSx = (textFocus, textError, textReadonly) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      outline: "none",
    },
    "&.MuiOutlinedInput-root": {
      borderRadius: "4px",
      border: textError
        ? `1px solid ${dangerColor}`
        : textFocus
          ? `1px solid ${focusColor}`
          : `1px solid ${regularColor}`,
      width: "100%",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& input::placeholder": {
      color: placeholderColor,
    },
    "& textarea::placeholder": {
      color: placeholderColor,
    },
    ...textReadonly && {
      cursor: "auto",
    },
    '& input::-ms-reveal': { // Removes the eye icon in Microsoft Edge 
      display: 'none',
    },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": { //Removes arrows from input type=number, for chrome/safari/edge/opera
      display: "none",
    },
    "& input[type=number]": { //Removes arrows from input type=number, for firefox
      MozAppearance: "textfield",
    },
  };
};

export const selectionSx = (
  selectionFocus,
  selectionError,
  selectionDisabled,
  selectionReadonly
) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      outline: "none",
    },
    "&.MuiOutlinedInput-root": {
      borderRadius: "4px",
      border: selectionError
        ? `1px solid ${dangerColor}`
        : selectionFocus
          ? `1px solid ${focusColor}`
          : `1px solid ${regularColor}`,
      width: "100%",
    },
    "& .MuiOutlinedInput-input": {
      ...(selectionDisabled && { cursor: "not-allowed" }),
      fontSize: "14px",
    },
    ...selectionReadonly && {
      '& .MuiSelect-select': {
        cursor: 'text',
        userSelect: "text",
      },
    },
  };
};

export const menuItemSx = () => {
  return {
    "&.MuiMenuItem-root": {
      whiteSpace: "normal",
      fontSize: 14,
    },
  };
};

export const datePickerSx = (datepickerFocus, datepickerError) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      outline: "none",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      border: datepickerFocus
        ? `1px solid ${focusColor}`
        : datepickerError
          ? `1px solid ${dangerColor}`
          : `1px solid ${regularColor}`,
      fontSize: 14,
    },
    "&.MuiTextField-root": {
      width: "100%",
    },
    "& .MuiButtonBase-root": {
      color: datepickerFocus ? focusColor : regularColor,
    },
    "& input::placeholder": {
      color: placeholderColor,
    },
  };
};
